import { apiClient } from './setupApi';

const SUPPORT = '/support';
const CUSTOMER = '/customer';

export const getSearchCustomerSupport = async (payload) => {
  const data = await apiClient.get(`${SUPPORT}/subscriber/search`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestSubscriberSupport = async (id) => {
  const { data } = await apiClient.get(`${SUPPORT}/subscribers/${id}`);
  return data;
};

export const requestCreateApplication = async (payload) => {
  const data = await apiClient.post(`${SUPPORT}/bonus_requests`, payload);
  return data;
};

export const requestGetApplications = async (filter) => {
  const { data } = await apiClient.get(`${SUPPORT}/bonus_requests`, {
    params: {
      ...filter
    }
  });
  return data;
};

export const requestGetApplicationsByManagerId = async (filter, managerId) => {
  const { data } = await apiClient.get(`${SUPPORT}/bonus_requests/managers/${managerId}`, {
    params: {
      ...filter
    }
  });
  return data;
};

export const requestGetDetailedApplication = async (id) => {
  const { data } = await apiClient.get(`${SUPPORT}/bonus_requests/${id}`);
  return data;
};

export const requestPatchHandlerApplication = async (id, payload) => {
  const data = await apiClient.patch(`${SUPPORT}/bonus_requests/${id}`, payload);
  return data;
};

export const requestGetBalance = async (iin) => {
  const data = await apiClient.get(`${CUSTOMER}/${iin}/balance`);
  return data;
};

export const requestGetTransactions = async (iin, payload) => {
  const data = await apiClient.get(`${SUPPORT}/subscriber/${iin}/transactions`, { params: {...payload } });
  return data;
};

export const requestGetBonuses = async (iin) => {
  const data = await apiClient.get(`${CUSTOMER}/${iin}/bonuses`);
  return data;
};

export const requestExportCustomers = async (dates) => {
  const { data } = await apiClient.get(`${CUSTOMER}/export_customers_by_date`, { params: dates, responseType: 'blob' })
  return data
}
